import { useEffect, useState } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
// import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb';
import SectionWrapper from '../../components/SectionWrapper/SectionWrapper';

import { useImportType } from '../../hooks/importType/useImportType';
import { useImportExcel } from '../../hooks/import/useImportExcel';
import ImportForm from '../../components/Import/ImportForm';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

const ImportPage = () => {
  const [selectedImportTypeId, setSelectedImportTypeId] = useState<number | null>(null);

  const { importTypeDropdown, fetchImportTypeDropdown } = useImportType();
  const {
    importCode,
    file,
    handlerImportExcel,
    handlerSetImportCode,
    handlerSetImportFile,
    handlerResetImportState,
  } = useImportExcel();

  useEffect(() => {
    fetchImportTypeDropdown();
  }, []);

  const handleImportTypeChange = (id: number | null) => {
    setSelectedImportTypeId(id);
    if (id) {
      const selected = importTypeDropdown.find((type) => type.id === id);
      if (selected?.code) {
        handlerSetImportCode(selected.code);
      }
    } else {
      handlerResetImportState();
    }
  };

  const handleFileChange = (selectedFile: File | null) => {
    handlerSetImportFile(selectedFile);
  };

  const handleReset = () => {
    setSelectedImportTypeId(null);
    handlerResetImportState();
  };

  useEffect(() => {
    if (!file && !importCode) {
      setSelectedImportTypeId(null); // ✅ Resetea el tipo seleccionado visualmente
    }
  }, [file, importCode]);

  return (
    <DefaultLayout>
      {/* <Breadcrumb pageName="Importación de Datos" /> */}
      <BreadcrumbTwo />

      <SectionWrapper>
        <ImportForm
          availableImportTypes={importTypeDropdown}
          selectedImportTypeId={selectedImportTypeId}
          onImportTypeChange={handleImportTypeChange}
          onFileChange={handleFileChange}
          onReset={handleReset}
          onImport={handlerImportExcel}
          currentFile={file}
          onClearState={() => handlerSetImportFile(null)}
        />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default ImportPage;
